import React from 'react';
import PropTypes from 'prop-types';

const HorizontalRule = ({ styling }) => <div data-test-id="horizontal-rule" style={{ backgroundColor: '#EDEDED', width: '100%', height: 1, marginBottom: 10, ...styling }} />;

HorizontalRule.propTypes = {
    styling: PropTypes.object,
};

HorizontalRule.defaultProps = {
    styling: {},
};

export default HorizontalRule;
